<button
  [ngClass]="{'rounded-button': true, 'active': isActive}"
  [type]="type"
  (click)="buttonClick.emit()">
    <span>{{text}}</span>
</button>
